import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./PoiReportConfirmation.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import AmpButton from "../../common/AmpButton/AmpButton";

export interface PoiConfirmationModalProps {
    onOk: () => void;
    onCancel: () => void;
}

export default function PoiConfirmationModal(props: PoiConfirmationModalProps) {

    const { t } = useTranslation(["nbhd", "login"]);

    return (<>
        <div className={styles.PoiConfirm}>
            <div><FontAwesomeIcon icon={faWarning} size="3x" /></div>
            <p>{t("nbhd.POI.view-modal-1")}</p>
        </div>
        <div className={styles.PoiConfirm}>
            <AmpButton onClick={(e) => props.onOk()} type={"submit"} text={t("confirm", {ns: "login"})}></AmpButton>
            <AmpButton onClick={(e) => props.onCancel()} type={"cancel"} text={t("cancel", {ns: "login"})}></AmpButton>
        </div>
    </>)
}

